import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Component } from '@angular/core';

@Component({
  selector: 'nggc-mission-result-renderer',
  standalone: true,
  template: `
    <span :class="missionSpan">
      @if (value) {
        <img
          [alt]="value"
          [src]="'https://www.ag-grid.com/example-assets/icons/' + value + '.png'"
          [height]="30"
          :class="missionIcon"
        />
      }
    </span>
  `,
  styles: [
    'img { width: auto; height: auto; } span {display: flex; height: 100%; justify-content: center; align-items: center} ',
  ],
})
export class MissionResultRendererComponent implements ICellRendererAngularComp {
  // Init Cell Value
  public value!: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public agInit(params: any): void {
    this.refresh(params);
  }

  // Return Cell Value
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public refresh(params: any): boolean {
    this.value = params.value >= new Date() ? 'tick-in-circle' : 'cross-in-circle';
    return true;
  }
}
